// src/components/Header.js
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './hamburgerMenu';
import { useMenu } from '../context/menuContext';
import transparentLogo from "../Images/wickedLogoTransparent.png";


const dropdownItems = {
  services: [
    { to: "/services#signs", label: "Industrial Signs" },
    { to: "/services#design", label: "Design and Art" },
    { to: "/services#metalFab", label: "Fabrication" },
  ],
  portfolio: [
    { to: "/portfolio/signs", label: "SIGNS" },
    { to: "/portfolio/art", label: "ART" },
  ],
  info: [
    { to: "/info/form", label: "Contact Us" },
    { to: "/faq/form", label: "F.A.Q" },
  ],
};

const Header = () => {
  const { menuOpen, setMenuOpen, openDropdown, setOpenDropdown } = useMenu();

  const dropdownRefs = {
    services: useRef(null),
    portfolio: useRef(null),
    info: useRef(null),
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutside = Object.values(dropdownRefs).every((ref) => {
        return !(ref.current && ref.current.contains(event.target));
      });

      if (clickedOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="flex items-center justify-between p-4 text-white relative z-50">
      
      {/* Mobile Hamburger Button */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="lg:hidden"
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <svg className="w-10 h-10 sm:w-20 sm:h-20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          />
        </svg>
      </button>

      {/* Desktop Menu with styles*/}
      <nav className="hidden lg:block sticky top-0 bg-opacity-70 z-20 bg-gray-900 p-2 shadow-sm rounded-md" 
      aria-label="Main navigation"
      >
        <ul className="flex space-x-4 p-2 rounded-md border-green-500 border-2">
          <li><Link to="/" className="hover:underline">HOME</Link></li>
          <li><Link to="/about" className="hover:underline">ABOUT</Link></li>

          {/* Dropdowns */}
          {Object.keys(dropdownItems).map((menuKey) => (
            <li key={menuKey} className="relative">
              <button
                onClick={() => toggleDropdown(menuKey)}
                className="hover:underline"
                aria-haspopup="true"
                aria-expanded={openDropdown === menuKey}
                aria-controls={`${menuKey}-menu`}
              >
                {menuKey.toUpperCase()} ▾
              </button>

              <div ref={dropdownRefs[menuKey]}>
                {openDropdown === menuKey && (
                  <ul
                    id={`${menuKey}-menu`}
                    className={`absolute mt-2 bg-white text-black shadow-lg rounded-md z-50 ${
                    menuKey === "info" ? "right-0" : "left-0"}`}
                    role="menu"
                  >
                    {dropdownItems[menuKey].map(({ to, label }) => (
                      <li key={to} role="none">
                        <Link
                          to={to}
                          role="menuitem"
                          className="block px-2 text-center py-2 hover:bg-gray-200 text-sm"
                        >
                          {label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          ))}
        </ul>
      </nav>
        {/* Social Media Icons */}
      <section className="hidden lg:block">
       <a href="https://www.facebook.com/p/Wicked-Fabrication-Llc-100069697879112/" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 text-2xl">
                  <i className="bi bi-facebook p-2"></i>
                  
                </a>
       <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className=" hover:text-green-500 text-2xl">
                  <i className="bi bi-instagram p-2"></i>
                </a>
      <a href="https://www.linkedin.com/in/tim-williams-26a7a7116/" target="_blank" rel="noopener noreferrer" className=" hover:text-green-500 text-2xl">
                  <i className="bi bi-linkedin p-2"></i> </a>

       <a href="https://www.tiktok.com/@wickedfabricationllc?lang=en" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 text-2xl">
                  <i className="bi bi-tiktok p-2"></i>
                  
                </a>
      </section>

      {/* Mobile Hamburger Menu Content */}
      <HamburgerMenu />
    </header>
  );
};

export default Header;
